exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cssload-container {\n    display: inline-block;\n}\n\n.cssload-speeding-wheel {\n\twidth: 1.4em;\n\theight: 1.4em;\n\tmargin: 0 auto;\n\tborder: 3px solid rgb(0,0,0);\n\tborder-radius: 50%;\n\tborder-left-color: transparent;\n\tborder-right-color: transparent;\n\tanimation: cssload-spin 575ms infinite linear;\n\t\t-o-animation: cssload-spin 575ms infinite linear;\n\t\t-ms-animation: cssload-spin 575ms infinite linear;\n\t\t-webkit-animation: cssload-spin 575ms infinite linear;\n\t\t-moz-animation: cssload-spin 575ms infinite linear;\n}\n\n@keyframes cssload-spin {\n\t100%{ transform: rotate(360deg); transform: rotate(360deg); }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/spinner/spinner.component.css
// module id = ../../../../../src/app/spinner/spinner.component.css
// module chunks = main